import React, { ReactNode } from 'react';
import styled, { css, keyframes } from 'styled-components';
import Scroll from 'react-scroll';
import queryString from 'query-string';
import ReactGA from 'react-ga';

import { withRouter, RouteComponentProps } from 'react-router-dom';
import MainLayout, { SearchContent, SearchPanel } from '../../common/Layout';
import PathUI from './PathUI';
import PathContent from './PathContent';
import TopicNetwork from './TopicNetwork.jsx';
import Patent from './Patent';
import RecommendedWord from './RecommendedWord';
import SearchListAI from '../viewMore/SearchListAI';

import { NetworkData, Result, Payload } from '../../../lib/tabAI/type';
import {
  GET_PATH_NETWORK_RECOMMEND_INFO,
  tabAIState,
} from '../../../modules/tabAI';

import { GetPathNetworkRecommendParamType2 } from '../../../lib/tabAI/recommendType';

import IconRightArrow from '../../../assets/icon/ic-right-blue@2x.png';
import SkeletonCard from '../common/SkeletonCard';
import { NoDataTitle } from '../common/Layout';
import { GetTotalRecommendParamType } from '../../../lib/main/type';
import { PostConsumptionBodyType } from '../../../lib/common/type';

const { Element } = Scroll;

type styleType = {
  dotColor: number;
};

const AIRecommendComponent = styled(MainLayout)``;

const PathResultBox = styled.div`
  display: flex;
  &:last-child {
    .PathContentComponent {
      margin-bottom: 0px;
    }
  }
  /* height: 100%; */
`;
const LeftLineBox = styled.div`
  margin-top: 5px;
  width: 11px;
  height: initial;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const LeftLineDot = styled.div`
  width: 11px;
  height: 11px;
  border-radius: 5.5px;
  background-color: #1a0dab;
  ${(props: styleType) => {
    if (props.dotColor === 0) {
      return css`
        background-color: #1a0dab;
      `;
    }
    if (props.dotColor === 1) {
      return css`
        background-color: #24b1f2;
      `;
    }
    if (props.dotColor === 2) {
      return css`
        background-color: #14ccad;
      `;
    }
    return css``;
  }}
`;
const LeftLineLine = styled.div`
  width: 0px;
  height: 100%;
  border: solid 1px #e1e6f0;
`;

const NoDataBox = styled.div`
  margin-top: 44px;
`;

const NoDataDesc = styled.div`
  font-family: 'NotoKrL';
  font-size: 14px;
  color: #222222;
  margin-top: 6px;
`;
const NoDataLinkBox = styled.div`
  display: flex;
  align-items: center;
  margin-top: 6px;
  color: #1a0dab;
  cursor: pointer;
  /* :hover {
    text-decoration: underline;
  } */
`;
const NoDataLinkTitle = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-family: 'NotoKrM';

  font-size: 14px;

  div:last-child {
    font-family: 'NotoKrL';
  }
`;
const NoDataLinkIcon = styled.img`
  margin-right: 2px;
  height: 15px;
`;

const MainContent = styled.div`
  width: 100%;
  height: 100%;
`;

function isString(val: string | string[]): val is string {
  return typeof val === 'string';
}

interface AIRecommendProps extends RouteComponentProps {
  onSetMenuID: (selectedMenuId: number) => void;

  onSetIsMoreInfoPath0: (
    isMoreInfoPath0: tabAIState['isMoreInfoPath0']
  ) => void;
  onSetIsMoreInfoPath1: (
    isMoreInfoPath1: tabAIState['isMoreInfoPath1']
  ) => void;
  onSetIsMoreInfoPath2: (
    isMoreInfoPath2: tabAIState['isMoreInfoPath2']
  ) => void;

  onSetIsMoreInfoPathAttach0: (
    isMoreInfoPathAttach0: tabAIState['isMoreInfoPathAttach0']
  ) => void;
  onSetIsMoreInfoPathAttach1: (
    isMoreInfoPathAttach1: tabAIState['isMoreInfoPathAttach1']
  ) => void;
  onSetIsMoreInfoPathAttach2: (
    isMoreInfoPathAttach2: tabAIState['isMoreInfoPathAttach2']
  ) => void;

  onGetPathNetwork2: (info: GetPathNetworkRecommendParamType2) => void;

  onPostConsumption: (info: PostConsumptionBodyType) => void;
  patentData: tabAIState['patentData'];
  recommendedWord: tabAIState['recommendedWord'];
  isMoreInfoPath0: tabAIState['isMoreInfoPath0'];
  isMoreInfoPath1: tabAIState['isMoreInfoPath1'];
  isMoreInfoPath2: tabAIState['isMoreInfoPath2'];
  isMoreInfoPathAttach0: tabAIState['isMoreInfoPathAttach0'];
  isMoreInfoPathAttach1: tabAIState['isMoreInfoPathAttach1'];
  isMoreInfoPathAttach2: tabAIState['isMoreInfoPathAttach2'];

  crawler_data_ai_network_data: tabAIState['crawler_data_ai_network_data'];
  crawler_data_ai_recommend_path: tabAIState['crawler_data_ai_recommend_path'];
  crawler_data_ai_results: tabAIState['crawler_data_ai_results'];
  crawler_data_ai_total_counts: tabAIState['crawler_data_ai_total_counts'];
  loading: boolean;
}

interface AIRecommendState {
  innerWidth: number;
}

class AIRecommend extends React.PureComponent<
  AIRecommendProps,
  AIRecommendState
> {
  state = {
    innerWidth: window.innerWidth,
  };

  componentDidMount() {
    ReactGA.ga('send', 'event', `view_search_ai_tab`);
    this.setState({
      innerWidth: window.innerWidth,
    });
    window.addEventListener('resize', () => {
      this.setState({
        innerWidth: window.innerWidth,
      });
    });
  }

  makePathContentList = (): ReactNode[] | null => {
    const {
      onSetIsMoreInfoPath0,
      onSetIsMoreInfoPath1,
      onSetIsMoreInfoPath2,
      onSetIsMoreInfoPathAttach0,
      onSetIsMoreInfoPathAttach1,
      onSetIsMoreInfoPathAttach2,
      onPostConsumption,
      crawler_data_ai_results,
      crawler_data_ai_recommend_path,
      crawler_data_ai_total_counts,
    } = this.props;

    const results: ReactNode[] | null = [];

    if (crawler_data_ai_results.length > 0) {
      if (crawler_data_ai_recommend_path) {
        crawler_data_ai_results.forEach((element, index) => {
          results.push(
            <PathResultBox>
              <LeftLineBox>
                <Element name={`aivoryPath${index}`} />
                <LeftLineDot dotColor={index} />
                <LeftLineLine />
              </LeftLineBox>
              <PathContent
                indexPath={index}
                pathData={crawler_data_ai_recommend_path}
                countData={crawler_data_ai_total_counts}
                recommendData={element}
                onPostConsumption={onPostConsumption}
                onSetIsMoreInfoPath0={onSetIsMoreInfoPath0}
                onSetIsMoreInfoPath1={onSetIsMoreInfoPath1}
                onSetIsMoreInfoPath2={onSetIsMoreInfoPath2}
                onSetIsMoreInfoPathAttach0={onSetIsMoreInfoPathAttach0}
                onSetIsMoreInfoPathAttach1={onSetIsMoreInfoPathAttach1}
                onSetIsMoreInfoPathAttach2={onSetIsMoreInfoPathAttach2}
              />
            </PathResultBox>
          );
        });
      }
    }

    return results;
  };

  makeViewMoreList = (): ReactNode[] | null => {
    const {
      isMoreInfoPath0,
      isMoreInfoPath1,
      isMoreInfoPath2,
      crawler_data_ai_results,
      crawler_data_ai_total_counts,
      loading,
      onSetIsMoreInfoPath0,
      onSetIsMoreInfoPath1,
      onSetIsMoreInfoPath2,
      onPostConsumption,
    } = this.props;
    const resultReactNode: ReactNode[] | null = [];
    if (isMoreInfoPath0) {
      resultReactNode.push(
        <SearchListAI
          openid={0}
          isMoreInfoPath0={isMoreInfoPath0}
          onSetIsMoreInfoPath0={onSetIsMoreInfoPath0}
          onPostConsumption={onPostConsumption}
          results={crawler_data_ai_results}
          total_counts={crawler_data_ai_total_counts}
          loading={loading}
        />
      );
    } else if (isMoreInfoPath1) {
      resultReactNode.push(
        <SearchListAI
          openid={1}
          isMoreInfoPath1={isMoreInfoPath1}
          onSetIsMoreInfoPath1={onSetIsMoreInfoPath1}
          onPostConsumption={onPostConsumption}
          results={crawler_data_ai_results}
          total_counts={crawler_data_ai_total_counts}
          loading={loading}
        />
      );
    } else if (isMoreInfoPath2) {
      resultReactNode.push(
        <SearchListAI
          openid={2}
          isMoreInfoPath2={isMoreInfoPath2}
          onSetIsMoreInfoPath2={onSetIsMoreInfoPath2}
          onPostConsumption={onPostConsumption}
          results={crawler_data_ai_results}
          total_counts={crawler_data_ai_total_counts}
          loading={loading}
        />
      );
    }

    return resultReactNode;
  };

  makeNodataList = (): ReactNode[] | null => {
    const { loading, location, history } = this.props;

    const query = queryString.parse(location.search);
    let keyword: string | string[] = '';
    if (query.q) {
      if (isString(query.q)) {
        keyword = query.q;
      } else {
        const index = 0;
        keyword = query.q[index];
      }
    }

    const result: ReactNode[] | null = [];
    if (loading) {
      result.push(<SkeletonCard />);
    } else {
      result.push(
        <NoDataBox>
          <NoDataTitle>
            <em>&#39;{keyword}&#39;</em>
            <div>에 대한 추천 결과가 없습니다.</div>
          </NoDataTitle>
          <NoDataDesc>
            AI 추천을 위해서 조금 더 많은 콘텐츠를 확인해 주세요!  
          </NoDataDesc>
          <NoDataLinkBox
            onClick={() => {
              history.push(`/search/result?q=${keyword}`);
              window.location.reload();
            }}
          >
            <NoDataLinkIcon src={IconRightArrow} />
            <NoDataLinkTitle>
              <div>&#39;{keyword}&#39;</div>
              <div>에 대한 검색결과 보기</div>
            </NoDataLinkTitle>
          </NoDataLinkBox>
        </NoDataBox>
      );
    }

    return result;
  };

  render() {
    const {
      patentData,
      recommendedWord,
      isMoreInfoPath0,
      isMoreInfoPath1,
      isMoreInfoPath2,
      isMoreInfoPathAttach0,
      isMoreInfoPathAttach1,
      isMoreInfoPathAttach2,
      crawler_data_ai_recommend_path,
      crawler_data_ai_total_counts,
      crawler_data_ai_network_data,
      crawler_data_ai_results,
    } = this.props;
    const { innerWidth } = this.state;

    return (
      <AIRecommendComponent>
        <SearchContent>
          {/* 더 보기 리스트 */}
          {isMoreInfoPath0 || isMoreInfoPath1 || isMoreInfoPath2
            ? this.makeViewMoreList()
            : null}

          {/* 메인 콘텐츠 */}
          {isMoreInfoPath0 ||
          isMoreInfoPath1 ||
          isMoreInfoPath2 ||
          isMoreInfoPathAttach0 ||
          isMoreInfoPathAttach1 ||
          isMoreInfoPathAttach2 ? null : (
            <MainContent>
              {crawler_data_ai_recommend_path &&
              crawler_data_ai_results.length > 0 &&
              crawler_data_ai_recommend_path.length > 0 ? (
                <MainContent>
                  <PathUI
                    recommend_path={crawler_data_ai_recommend_path}
                    total_counts={crawler_data_ai_total_counts}
                  />

                  {innerWidth < 1100 ? (
                    <TopicNetwork
                      crawler_data_ai_network_data={
                        crawler_data_ai_network_data
                      }
                    />
                  ) : null}
                  {this.makePathContentList()}
                </MainContent>
              ) : (
                this.makeNodataList()
              )}
            </MainContent>
          )}
        </SearchContent>
        <SearchPanel>
          {innerWidth < 1100 ? null : (
            <TopicNetwork
              crawler_data_ai_network_data={crawler_data_ai_network_data}
            />
          )}

          {patentData.patent &&
          patentData.patent.length > 0 &&
          patentData.patent !== 'patent null' ? (
            <Patent patentData={patentData} />
          ) : null}
          {recommendedWord.length > 0 ? (
            <RecommendedWord recommendedWord={recommendedWord} />
          ) : null}
        </SearchPanel>
      </AIRecommendComponent>
    );
  }
}

export default withRouter(AIRecommend);
